var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSolution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368,192H192V112a64,64,0,0,1,128,0,16,16,0,0,0,32,0,96,96,0,0,0-192,0v80H144a64.07,64.07,0,0,0-64,64V432a64.07,64.07,0,0,0,64,64H368a64.07,64.07,0,0,0,64-64V256A64.07,64.07,0,0,0,368,192Zm32,240a32,32,0,0,1-32,32H144a32,32,0,0,1-32-32V256a32,32,0,0,1,32-32H368a32,32,0,0,1,32,32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256,246a62.28,62.28,0,0,0-42.1,108.17V424a16,16,0,0,0,16,16h52.21a16,16,0,0,0,16-16V354.16A62.28,62.28,0,0,0,256,246Zm17.07,87.29a16,16,0,0,0-7,13.21V408H245.9V346.49a16,16,0,0,0-7-13.21,30.28,30.28,0,1,1,34.14,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolution);
export default __webpack_public_path__ + "static/media/icon-solution.e0cf083a.svg";
export { ForwardRef as ReactComponent };